const { errors, languages } = require('@transfeeradev/api-enums');

class ErrorMessageFinder {
  static findByMessage(message) {
    return this.#find(error => {
      if (error.message === message) {
        return error;
      }
    });
  }

  static #find(fn) {
    for (const language of Object.values(languages)) {
      for (const context of Object.values(errors[language])) {
        for (const error of Object.values(context)) {
          const found = fn(error);

          if (found) {
            return found;
          }
        }
      }
    }

    return null;
  }
}

module.exports = ErrorMessageFinder;
